module.exports = __webpack_public_path__ + "img/home_1.d482b6a0.png";